import Search from "./js-componets/Search";
window.siteMenu = (function () {
    const OPEN = 'menu-is-open';

    function open() {
        document.querySelector('body')
            .classList.add(OPEN)
    }

    function close() {
        document.querySelector('body')
            .classList.remove(OPEN)
    }

    function toggle() {
        document.querySelector('body')
            .classList.toggle(OPEN)
    }

    document.querySelectorAll('[data-open="menu"]')
        .forEach(e => e.addEventListener('click', toggle));
    return {
        open: open,
        close: close,
        toggle: toggle,
    }
})();

(function () {
    window.addEventListener('load', e => {
        document.addEventListener('click', event => {
            if (!event.target) {
                return;
            }
            if (!event.target.closest('[data-el="panel"]')) {
                return;
            }
            if (!event.target.closest('[data-panel="heading"]')) {
                return;
            }
            collapsible(event.target.closest('[data-el="panel"]'))
        })
        function collapsible(panel, action) {
            const heading = panel.querySelector('[data-panel="heading"]')
            const nowIsShow = heading.classList.contains('active')
            const show = !nowIsShow || action === 'show'
            const body = panel.querySelector('[data-panel="body"]');
            const parent = panel.parentElement.closest('[data-el="panel"]');
            if (show) {
                showPanel(panel, heading, body)
                if (parent) {
                    parent.querySelector('[data-panel="body"]').style.height = ''
                }
            } else {
                hidePanel(panel, heading, body)
            }
        }

        function showPanel(panel, heading, body) {
            panel.classList.add('active')
            body.style.height = body.scrollHeight + "px";
            heading.classList.add('active');
        }

        function hidePanel(panel, heading, body) {
            panel.classList.remove('active')
            if (!body.style.height) {
                body.style.height = body.scrollHeight + "px";
            }
            setTimeout(() => body.style.height = '');
            heading.classList.remove('active');
        }
    })

    Array.from(document.querySelectorAll('[data-search]'))
        .forEach(root => {
            let search = new Search({root})
            search.init()
        })
})();

if (!Array.isArray) {
    Array.isArray = function(arg) {
        return Object.prototype.toString.call(arg) === '[object Array]';
    };
}